module.exports = __webpack_public_path__ + "img/monitoring-phone.65a117cd.svg";